export const APP_NAME = "District & Municipal Water Intelligence Platform"
export const APP_SUBTITLE = "Digital STP Integration • Monitoring • Performance Intelligence • Treated-Water Reuse Planning"
/** The opening statement: what the platform is for, in one sentence. */
export const APP_STATEMENT =
  "Connect existing STP information, understand treatment capacity and performance, improve operational visibility, and evaluate treated-water reuse opportunities through one digital platform."
export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? "0.1.0"
/**
 * The API is same-origin by default (Vite dev proxy / nginx forward /api), so the
 * HttpOnly session cookie is first-party. Set VITE_API_URL only for a separate
 * API origin, which must then be listed in the API's ALLOWED_ORIGINS.
 */
export const API_BASE_URL = import.meta.env.VITE_API_URL || ""
export const API_V1 = `${API_BASE_URL}/api/v1`

export const QUERY_KEYS = {
  ME: ["auth", "me"],
  USERS: ["users"],
  ORGANIZATIONS: ["organizations"],
  ROLES: ["roles"],
  PERMISSIONS: ["permissions"],
  PLANTS: ["plants"],
  SENSORS: ["sensors"],
  ALERTS: ["alerts"],
  WORK_ORDERS: ["work-orders"],
  REPORTS: ["reports"],
  HEALTH_SCORES: ["health-scores"],
  AI_PREDICTIONS: ["ai-predictions"],
} as const

export const PAGE_SIZE = 50

export const STATUS_LABELS: Record<string, string> = {
  OPERATIONAL: "Operational",
  UNDER_MAINTENANCE: "Under Maintenance",
  COMMISSIONING: "Commissioning",
  DECOMMISSIONED: "Decommissioned",
  ACTIVE: "Active",
  INVITED: "Invited",
  SUSPENDED: "Suspended",
  DEACTIVATED: "Deactivated",
}

export const STATUS_COLORS: Record<string, string> = {
  OPERATIONAL: "status-operational",
  ACTIVE: "status-operational",
  UNDER_MAINTENANCE: "status-maintenance",
  COMMISSIONING: "status-commissioning",
  DECOMMISSIONED: "status-offline",
  SUSPENDED: "status-warning",
  DEACTIVATED: "status-offline",
  INVITED: "status-commissioning",
}

export const NAV_ITEMS = [
  { path: "/dashboard", label: "Dashboard", icon: "LayoutDashboard" },
  { path: "/plants", label: "Plants", icon: "Factory" },
  { path: "/telemetry", label: "Telemetry", icon: "Activity" },
  { path: "/alerts", label: "Alerts", icon: "Bell" },
  { path: "/maintenance", label: "Maintenance", icon: "Wrench" },
  { path: "/reports", label: "Reports", icon: "BarChart3" },
] as const

export const ADMIN_NAV_ITEMS = [
  { path: "/settings", label: "Settings", icon: "Settings" },
  { path: "/users", label: "Users", icon: "Users" },
] as const
